<template>
    <page title="订单查询">
        <keep-alive :include="['OrderQuery','orderList']">
            <router-view :key="key"></router-view>
        </keep-alive>
    </page>
</template>
<script>
    export default {
        computed: {
            key() {
                return this.$route.name;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/order/order-common.vue